// Tier-3 builder presentation seam (Phase 7A).
//
// The per-set RIR control. The canonical cycle `RIR_CYCLE = [2, 1, 0, 4, 3]`
// and `getNextRirValue` stay in the container; this component renders the
// button and reports the tap. RIR is reps-in-reserve, never RPE.
export default function RirControl({ value, disabled = false, onCycle }) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onCycle}
      className="lz-builder-rir"
      data-rir={String(Number(value))}
      aria-label={`RIR ${value}. Tap to cycle`}
    >
      {value}
    </button>
  );
}
